import _ from 'underscore';
import Backbone from 'backbone';

class ActionList {
    
    constructor(actions) {
        this.actions = actions;

        // this.actions.default gives us name 
        // of default action
        this.defaultAction = this.actions[this.actions.defaults]
        // mark default action
        if (this.defaultAction)
            this.defaultAction.defaults = true;
        // delete "default" key
        delete this.actions.defaults;

        // add code (backlink) to each action
        // (useful for handling)
        Object.keys( this.actions ).forEach( actionName =>
            this.actions[actionName].code = actionName );
    }
    
    // listen for "events" on "context"
    // and change state of actions accordingly
    // (trigger "update" event to recalc enabled/disabled properties)
    depend(context, events) {
        this.listenTo( context, events, () => this.trigger( 'update' ) );
    }

    clearDependencies( context ) {
        this.stopListening( context );
    }
    
    plug(eventSource) {
        if (!this.actions) return;
        
        Object.keys( this.actions ).forEach( eventName => 
            // event name is "action:<eventName>" 
            this.listenTo( eventSource, `action:${eventName}`,
                // create handler for this action
                getHandler( this.actions[eventName] ) ) );
            
        if (this.defaultAction)
            this.listenTo( eventSource, `action:default`,
                getHandler( this.defaultAction ) );
    }

    unplug(eventSource) {
        this.stopListening( eventSource );
    }
    
};

_.extend( ActionList.prototype, Backbone.Events );

export default ActionList;

function getHandler(action) {
    return (...args) => {
        // if info is a function, then it's handler
        // itself. Let's call it immediately
        if ('function' === typeof action)
            return action( ...args );
            
        // otherwise: 
        // - "disabled" property is a 
        // function that returns boolean flag
        // of availability of action
        // - "handler" property is a handler itself
        let disabled = action.disabled ? action.disabled() : false;
        
        if (!disabled)
            return action.handler( ...args );
    };
}


// WEBPACK FOOTER //
// ./src/js/actionList.js